import React, { useEffect, useMemo } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Admin from './admin/Admin'
import './App.css'
import AboutPage from './components/about/AboutPage'
import Auth from './components/auth/Auth'
import Main from './components/main/Main'
import Details from './components/products/details/Details'
import ProductPage from './components/products/ProductPage'
// import GlobalState from "./global/GlobalState";
import ProtectedRoute from './protected-route/ProtectedRoute'
import Cart from './components/cart/Cart'
import Checkout from './components/checkout/Checkout'
import User from './components/user/User'
import ScrollToTop from './protected-route/ScrollToTop'
import { useAppDispatch } from './store'
import { getInforUserAPI } from './redux/actions/userActions'
import { getCartAPI } from './redux/actions/cart-actions'

function App() {
  const dispatch = useAppDispatch()
  const location = useLocation()

  useEffect(() => {
    dispatch(getInforUserAPI())
    dispatch(getCartAPI())
  }, [dispatch])

  const prePath = useMemo(() => {
    return `${location.pathname}`
  }, [location])
  sessionStorage.setItem('return-to', prePath)

  return (
    // <GlobalState>
    <div>
      <ScrollToTop />
      <Routes>
        <Route path="/shop" element={<ProductPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/details/:productID" element={<Details />} />
        <Route element={<ProtectedRoute />}>
          <Route index path="/" element={<Main />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/user" element={<User />} />
        </Route>
        <Route path="/login" element={<Auth authRoute="login" />} />
        <Route path="/register" element={<Auth authRoute="register" />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </div>
    // </GlobalState>
  )
}
export default App
